class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Nomad navigation restructure (June 2026): open the desktop mega menu on hover,
// per the navigation brief ("all subcategories visible on hover"). Hover-capable,
// fine-pointer devices only — touch keeps the native tap-to-toggle behaviour.
// The mega panel is a DOM descendant of <header-menu>, so moving the cursor into
// the open panel does not fire mouseleave; a short close delay forgives the
// diagonal path from the summary into the panel.
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;
      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      });

      menu.addEventListener('mouseleave', () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        }, 200);
      });
    });
  });
}
